import { BaseModel } from './BaseModel';

import LearningUnit from './LearningUnit';

export class LearningUnitMember extends BaseModel {
  static get entity() {
    return 'learning-unit-members';
  }

  static get fk() {
    return 'learning_unit_id';
  }

  static fields() {
    return {
      id: this.uid(),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      user: this.attr(null),
      user_role: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      deleted_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params = {}, props = {}) {
        return this.get(
          '/learning-unit-members',
          {
            params
          },
          props
        );
      },

      fetchWithSubmissions(params = {}) {
        return this.get(
          '/learning-unit-members/count-submission',
          {
            params
          }
        );
      },

      addLearningUnitMember(body) {
        return this.post('/learning-unit-members', body);
      },

      removeMember(id) {
        return this.delete(`/learning-unit-members/${id}`, {
          delete: id
        });
      },

      removeMemberAssessor(id) {
        return this.delete(`/learning-unit-members/${id}/assessor`);
      }
    }
  };
}

export default LearningUnitMember;
